import React from 'react';
import classnames from 'classnames';
import { Button as BaseButton } from '@1c/ui';

import styles from './styles.module.scss';

type Props = {
  variant?: 'contained' | 'outlined' | 'text';
  className?: string;
  [x: string]: any;
};

const Button: React.FC<Props> = (props) => {
  const { variant = 'contained', className, ...rest } = props;
  const classNames = classnames(className, styles[variant], {
    [styles['disabled']]: props.disabled,
  });
  
  return (
    <BaseButton {...rest} size="xl" className={classNames}/>
  );
};

export default Button;
